<template>
	<div class="home">
		<!-- 头部 -->
		<div class="container-fluid ">
			<!-- 加载状态 -->
				<div class="loading" v-if="anate"><i class="fa fa-spin fa-refresh"></i><p>Loading</p></div>
			<div class="header">
			<div class="row ">
				<div class="col-lg-12 ">
					<nav class="navbar">
							<div class="navbar-header  ">
								<a class="navbar-brand" href="javascript:void(0);">
									<img class="logo" alt="Brand" src="../assets/logo.png">
								</a>
							<span v-show="show_icon&&btn_selected" @click="icon_mune">
								<i class="fa fa-align-justify left-menu"></i>
							</span>
							</div>  
							<div class="navbar-rigth">
								<span>{{language_item}}
									<select v-model="btn_selected" @change="menu_list(btn_selected)">
										<option disabled value="">{{language_please_select}}</option>
										<option v-for="(project,index) in project_list" :key="index" :value="project">{{project.Comment}}</option>
									</select>
								</span>
								<span>{{language_time_zone}}
									<select v-model="sle_zone" @change="sle_time">
										<option disabled value="">{{language_please_select}}</option>
										<option v-for="(item,index) in UTC_ZONE" :key="index" :value="item">{{item}}</option>
									</select>
								</span>
								<span>{{language_language}}
									<select v-model="select_language" @change="change_language(select_language)">
										<option disabled value="">{{language_please_select}}</option>
										<option v-for="(item,index) in language_type" :key="index" :value="item">{{item}}</option>
									</select>
								</span>
								<span>
									<span>{{language_welcome}}<b class="user_icon">{{username}}</b></span>
									<span class="out" @click="out">{{language_sign_out}}</span>
								</span>
							</div>
					</nav>
				</div>
			</div>
		</div>
		<!-- 左侧菜单栏 -->
			<div class="row">
				<div class=" menu" v-if="menu_show">
					<div class=" menu-list-one">{{project_name}}</div>
					<!-- 当点击头部列表时根据不同的接口显示不同的菜单数据 -->
					<div v-for="(menu_data,index) in menu_data" :key="index" :id="'menu_'+index">
						<div @click="change(index,menu_data.name)" class="menu-titel">
							<i class="fa fa-caret-right" :class="{'icon':is_icon===index}" aria-hidden="true"></i>
							{{menu_data.name}}
						</div>
						<ul class="menu-list" v-show="is_icon===index" style="margin-top: 10px;">
							<li @click="sty_list(sub,index)" class="menu_list" v-for="(sub,index) in menu_data.sub_item"
							 :key="index" :class="{'sty_list':is_sty===sub.name+index}"><a :title="sub.name" href="javascript:void(0)" class="list-anchor">{{sub.name}}</a></li>
						</ul>
					</div>
				</div>
				
				<div class="data" :class="[active]">
					<!-- <keep-alive> -->
					<component :is="is_components" :fld_status="fld_status" :language_pack="language_pack" :current_state="current_state" @parent_refresh="parent_refresh" 
						@lookup="lookup" @child_home="child_home" @child="child" @child_next="child_next" @child_end="child_end"
		 				@parent_data_sort="parent_data_sort" @query="query" :sub_url="sub_url" :sub_index="sub_index"
		            	:columns="columns" :rows="rows" :project_data="project_data" :total="total" :response="response"  :istrue="istrue" :isquery="isquery" 
		            	:no_data="no_data" @change_rows="change_rows" :sle_zone="sle_zone">
					</component>
					<!-- </keep-alive> -->
					<!-- 提示组件 -->
					<tips v-if="sel_tips" :current_state="current_state" :language_pack="language_pack"></tips>
				</div>
			</div>
		</div>
			<div class="row edition">
				<div class="col-lg-12 col-md-12 copyright">版权归玩娱互动</div>
		    </div>
	</div>
</template>
<script>
	//表格数据组件admin
	import contentAdmin from '@/components/content_admin.vue';
	//表格数据组件warship
	import contentWarship from '@/components/content_warship.vue';
	//角色查询组件
	import QueryRole from '@/components/query_role.vue';
	//邮件组件
	import SendMail from '@/components/send_mail.vue';
	//nacos组件
	// import nacos from '@/components/nacos';
	import EmailSiTitle from '@/components/email_si_title.vue';
	import EmailTitle from '@/components/email_title.vue';
	import ChildEmailSiTitle from '@/components/child_email_si_title.vue';
	import ChildEmailTitle from '@/components/child_email_title.vue';
	//弹框提示组件
	import tips from "../box/tips";
	//sdk配置组件
	import SetProgress from "@/components/set_progress.vue";
	import server_info from '@/components/server_info.vue';
	import { mapState } from 'vuex';
	import {mapMutations} from 'vuex';
	//语言包模块
	import language_pack from "../store/language_pack.js";
	import api from "../api/index.js"
	export default {
		name: 'Home',
		components: {
			contentAdmin,
			contentWarship,
			QueryRole,
			SendMail,
			server_info,
			tips,
			SetProgress,
			EmailSiTitle,
			EmailTitle,
			ChildEmailSiTitle,
			ChildEmailTitle
		},
		data() {
			return {
				timeOut:'',
				//切换组件
				is_components:'',
				//选择语言
				select_language:'',
				//项目下拉框的索引
				project_index:'',
				//是否显示提示组件
				sel_tips:false,
				//当前的状态
				current_state:'',				
				//菜单显示隐藏时的布局
				active:'col-lg-12',
				//菜单的显示和隐藏
				menu_show:false,
				//时区
				UTC_ZONE:[
   					 "UTC-0000",
   					 "UTC-0100",
   					 "UTC-0200",
   					 "UTC-0300",
   					 "UTC-0400",
   					 "UTC-0500",
   					 "UTC-0600",
   					 "UTC-0700",
   					 "UTC-0800",
   					 "UTC-0900",
   					 "UTC-1000",
   					 "UTC-1100",
   					 "UTC-1200",
   					 "UTC+0000",
   					 "UTC+0100",
   					 "UTC+0200",
   					 "UTC+0300",
   					 "UTC+0400",
   					 "UTC+0500",
   					 "UTC+0600",
   					 "UTC+0700",
   					 "UTC+0800",
   					 "UTC+0900",
   					 "UTC+1000",
   					 "UTC+1100",
   					 "UTC+1200"
				],
				//时区选择框的数据
				sle_zone:'UTC+0800',
				//项目的选择框数据
				btn_selected:'',				
				//是否显示数据
				show_comment:'',
				//加载状态
				anate:false,				
				//头部请求的数据
				project_list: '',
				//头部数据项目返回的名字
				project_name: '',
				//项目菜单数据包括子菜单
				menu_data: '',
				//控制菜单三角图标
				is_icon: null,
				//用户名
				username: '',
				//菜单项的点击样式
				is_sty: '',
				//角色权限
				userInfo: '',
				//项目内容数据
				rows: [],
				//项目头部数据
				fields: null,
				//项目内容的数据
				project_data: {},
				total:null,
				//头部数据和其他的增删改接口
				response: {},
				//地址路由参数
				sub_url: null,
				//地址路由参数
				sub_index: null,
				list_index: 0,
				//菜单显示隐藏的索引值
				change_index: 0,
				//上下翻页时数据请求完成执行代码
				istrue: {
					isnext: true,
					isfirst: true,
					isstart: true,
					isend: true,
					isrefresh: true,
					isorder: true,
					//当执行小x号完成在执行子组件函数
					isclose:true,
				},
				//是否查询列表数据
				isquery:false,
				//查询的数据参数
				query_projectA:null,
				//请求数据页的显示条数
				data_page: 16,
				//请求的页数默认为一页
				page:1,
				//查询的数据是否为空的标志
				no_data:true,
				//获取url中的参数
				surl:null,
				//获取url中的index参数
				index:null,
				//获取url中的子菜单的index
				change_index:null,
				//正反序的状态
				sord:'desc',
				//选择项目的副本
				copy_select:null,
				//头部数据
				columns:null,
				//是否显示头部icon
				show_icon:true,
				//语言类型
				language_type:['中文','English','日本語'],
				//语言包
				language_pack:language_pack,
				title:null,
				select:'',
				time_control:null,
				flag:true,//刷新时子条目不重新执行
				fld_status:'',//邮件判断是否为已完成的邮件
			}
			
		},
		created() {
			this.login_expired();
			this.get_title();
			this.getHeadData();
		},
		computed: {
			...mapState({
				sel_language:'sel_language',
				language_item(){return this.language_pack[this.sel_language].item},
				language_time_zone(){return this.language_pack[this.sel_language].time_zone},
				language_language(){return this.language_pack[this.sel_language].language},
				language_welcome(){return this.language_pack[this.sel_language].welcome},
				language_sign_out(){return this.language_pack[this.sel_language].sign_out},
				language_please_select(){return this.language_pack[this.sel_language].Please_select},
				language_login_expired(){return this.language_pack[this.sel_language].login_expired},
			})
		},
		mounted() {

		},
		watch:{
			$route(){
				if(this.menu_data){
					this.request_item();
					this.get_title();
				}
			},			
		},
		methods: {  
			//根据默认主键id查询子表数据
			async change_rows(para,parent,fld_status){
				// alert('888888888')
				console.log('routerPath',this.$route.path)

				this.flag=false;
				let res = await this.async_error(api.getTableHead(this.$route.path,window.sessionStorage.getItem('userInfo')))
				this.columns = res.data;
				this.fields=res.data.FIELDS;
				this.response = res.data;
				this.total=res.data.total;
				this.response = res.data;
				this.fld_status=fld_status;
						// this.total=res.data.total;
						//获取项目的表头数据 项目表格中的标题
						// this.columns = res.data;
						// this.fields=res.data.FIELDS;
						// console.log(para)
						para.sidx=this.columns.PRIMARY
				let res1 = await this.async_error(api.getTableList(this.columns,para))					
				this.rows=res1.data.rows;
				this.project_data = res1.data;
				this.anate=false;				
				//更新时区
				this.update_timezone(this.$route.path,res1);
				// console.log(parent)
				if(parent=='/Sandbox/Other/EmailSiTitle'&&this.$route.path=='/Sandbox/Launcher/tbl_email'){
					// alert(0)
					this.flag=true;
					this.is_components='ChildEmailSiTitle'
				}else if(parent=='/Sandbox/Other/EmailTitle'&&this.$route.path=='/Sandbox/Launcher/tbl_email'){
					// alert(1)
					this.flag=true;
					this.is_components='ChildEmailTitle'
				}else{
					this.is_components='contentAdmin'
				}		
			},
			//改变语言
			...mapMutations(['change_lan']),
			//前进后退时的保持项目和菜单的状态
			switch_routing_state(){
				this.copy_select=window.sessionStorage.getItem('btn_selected');
				//刷新前进后退时保持菜单和选择框的状态
				this.project_list.forEach((item,index)=>{
					if(item.Name==this.$route.params.project){
						window.sessionStorage.setItem('btn_selected',index);
						window.sessionStorage.setItem('page',1);
						this.copy_select=window.sessionStorage.getItem('btn_selected');
					}
				})
			},
			//切换路由时的状态以及接口
			switch_routing_interface(){
				if (this.$route.params.project != undefined) {
					let sord='desc';
					this.surl = "/" + this.$route.params.project + '/' + this.$route.params.db + '/' + this.$route.params.table;
					//刷新时执行头部菜单中的函数并传入路由参数 项目对象 后台路由 菜单索引 子菜单索引
					if(this.btn_selected.Name==this.$route.params.project){
						this.is_icon=null;
						this.menu_data.forEach((item,index)=>{
							item.sub_item.forEach((change_item,change_index)=>{
								if(this.surl==change_item.url){
									window.sessionStorage.setItem('index',change_index);
									window.sessionStorage.setItem('change_index',index);
									this.index=Number(window.sessionStorage.getItem('index'));
									this.change_index=Number(window.sessionStorage.getItem('change_index'));
								}
							})
						})
						//改变小三角样式的函数
						window.sessionStorage.setItem('title',this.menu_data[this.change_index].sub_item[this.index].name)
						if(this.change_index!=undefined){
							this.change(this.change_index);
						}
					}else{
						console.log('获取项目信息：',this.project_list);
						console.log('this.copy_select',this.copy_select)
						console.log('this.surl',this.surl)
						//当项目变化后前进后退会重新加载项目列表
						this.menu_list(this.project_list[this.copy_select],this.surl, this.index, this.change_index);	
					}	
					
					if(this.flag){
							// alert('---------') 					
						this.getRow(this.surl, this.index,this.project_list[this.copy_select],sord);
					}
					this.flag=true;
				}
				if (this.$route.params.project == undefined) {
					document.title='Background-management-system';
					this.sel_tips=true;
					this.current_state=this.language_login_expired;
					window.setTimeout(()=>{
						this.sel_tips=false;
						//返回登录页面
						this.$router.replace({
							path: "/login"
						})
					},1000)					
				}
			},
			//当路由发生变化时请求项目
			request_item(){
				// alert(0)
				//取消查询的标志
				this.isquery=false;
				//请求项目列表时判断是否超时
				this.login_expired();
				window.sessionStorage.setItem('project','');
				if(this.time_control<0 && window.sessionStorage.getItem('userInfo')!='null'){
					//刷新时根据之前保存的时区显示时间
					this.sle_zone=this.keep_timezone();
					this.change_lan(window.sessionStorage.getItem('sel_language'));
					this.switch_routing_state();
					//根据保存的项目为空时会自动请求第一个项目默认显示(当退出时再次登录会加载到推出前的页面)
					this.get_item()
					this.index=Number(window.sessionStorage.getItem('index'));
					this.change_index=Number(window.sessionStorage.getItem('change_index'));
					//如果url参数不为undefined加载对应路由的数据
					this.switch_routing_interface();	
				}
			},
			//获取title
			get_title(){
				if(window.sessionStorage.getItem('title')){
					let title=window.sessionStorage.getItem('title');
					document.title=title;
				}else{
					document.title='Background-management-system';
				}
			} ,  
			//保存时区字段（当刷新时时区不变）
			 keep_timezone(){
				if(window.sessionStorage.getItem('time_zone')!=null){
					return window.sessionStorage.getItem('time_zone');
				}else{
					return 'UTC+0000'
				}
			 },  
			//获取第一个项目（如果项目没有被缓存直接加载第一个项目） 
			get_item(){
				if(this.copy_select!=''&&this.$route.params.project == undefined){
					//获取参数地址中的参数
					let params_url=window.sessionStorage.getItem('url');
					//如果本地保存的数据中有值
					if(params_url){
						this.$router.push(params_url);
					}else{
						//如果参数为空那么直接加载第一个菜单
						this.menu_list(this.project_list[0]);
						this.btn_selected=this.project_list[0];
					}
				}
			},
			//刷新时执行对应的页面接口
			refresh_page_interface(){
				var project;
				if(!window.sessionStorage.getItem('project')){
					project=''
				}else{
					project=JSON.parse(window.sessionStorage.getItem('project'));
				}
				this.index=Number(window.sessionStorage.getItem('index'));
				this.change_index=Number(window.sessionStorage.getItem('change_index'));
				//当重新加载时请求反序的数据
				let sord=window.sessionStorage.getItem('sord');
				//如果url参数不为undefined加载对应路由的数据
				if (this.$route.params.project != undefined) {
					this.surl = "/" + this.$route.params.project + '/' + this.$route.params.db + '/' + this.$route.params.table;
					// console.log(this.surl)
					//刷新时执行头部菜单中的函数并传入路由参数 项目对象 后台路由 菜单索引 子菜单索引
					this.menu_list(this.project_list[this.copy_select],this.surl, this.index, this.change_index);
					//获取数据时执行的函数 后台路由 菜单索引 子菜单索引 项目对象
					this.getRow(this.surl, this.index,this.project_list[this.copy_select],sord,project);
				}	
			},
			// 强制刷新时请求项目列表
			async getHeadData(){
				// alert('shuaxibn')
				window.sessionStorage.setItem('time_zone',this.sle_zone);
				if(this.time_control<0 && window.sessionStorage.getItem('userInfo')!='null'){
					let res = await this.async_error(api.getProjectList(window.sessionStorage.getItem('userInfo')));
					if(!res){
        			  return false
        			};
					if(res!=undefined){
						this.project_list = res.data;						
						if(res.data.error==-1){
							this.sel_tips=true;
							this.current_state=res.data.message;
							window.setTimeout(()=>{
								this.sel_tips=false;
							},2000)
							return false    
						}
						if(res.data.length==0){
							this.show_icon=false;
							this.sel_tips=true;
							this.current_state=this.sel_language.is_permission;
							window.setTimeout(()=>{
								this.sel_tips=false;							
							},2000)
							return false  
						}
						//刷新时根据之前保存的时区显示时间
						this.sle_zone=this.keep_timezone();
						//刷新时读取之前的语言状态
						this.change_lan(window.sessionStorage.getItem('sel_language'))
						//获取项目索引
						this.copy_select=window.sessionStorage.getItem('btn_selected');
						//根据保存的项目为空时会自动请求第一个项目默认显示(当退出时再次登录会加载到推出前的页面)
						this.get_item();
						//刷新时执行页面接口
						this.refresh_page_interface();		
					}					
				}
				// this.flag=true	 
			},
			//登陆超时
			login_timeout(){
				let time = parseInt(new Date().getTime() / 1000);
				//获取据1970年的时间毫秒数以判断登录过期时间
				let startTime = window.sessionStorage.getItem('startTime');
				//设置超时时间30分钟
				let time_control = (time - startTime) - (300*60);
				this.time_control=time_control;
				//登录时间超时返回登录页
				if (time_control > 0) {	
					window.sessionStorage.setItem('index',this.index);
					//保存选择项索引
					window.sessionStorage.setItem('btn_selected',this.project_index);
					//保存退出前的地址
					if(this.$route.params.project != undefined){
						window.sessionStorage.setItem('url',this.surl)
					};
					//保存userInfo
					window.sessionStorage.setItem('userInfo','null');
					document.title='Background-management-system';
					this.sel_tips=true;
					this.current_state=this.language_login_expired;
					window.setTimeout(()=>{
						this.sel_tips=false;
						//返回登录页面
					this.$router.replace({
						path: "/login"
					})
					},1000)
				}else{
					//当一直操做时时间也跟着更新避免30分钟后退出登录
					window.sessionStorage.setItem('startTime',time);
					let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
					//获取用户名
					this.username = userInfo.fld_name;
				}
			},
			//登录过期
			login_expired(){
				//如果userInfo为null那么返回登录页
				if(window.sessionStorage.getItem('userInfo')==null||window.sessionStorage.getItem('userInfo')=='null'){
					window.sessionStorage.setItem('index',this.index);
					document.title='Background-management-system';
					this.sel_tips=true;
					this.current_state=this.language_login_expired;
						this.sel_tips=false;
						//返回登录页面
					this.$router.replace({
						path: "/login"
					})
				}else{
					//把保存的用户信息转换成对象
					let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
					//保存到data对象中
					this.userInfo = userInfo;
					if (userInfo.fld_name == '' || userInfo.fld_name == undefined || userInfo.fld_name == null || userInfo.fld_name =='null') {
						window.sessionStorage.setItem('index',this.index);
						//保存选择项索引
						window.sessionStorage.setItem('btn_selected',this.project_index);
						//保存退出前的地址
						if(this.$route.params.project != undefined){
							window.sessionStorage.setItem('url',this.surl)
						};
						//保存userInfo
						window.sessionStorage.setItem('userInfo','null');
						document.title='Background-management-system';
						//返回登录页
						this.sel_tips=true;
					this.current_state=this.language_login_expired;
					window.setTimeout(()=>{
						this.sel_tips=false;
						//返回登录页面
					this.$router.replace({
						path: "/login"
					})
					},1000)
					};
					this.login_timeout();
				}
			},
			//头部菜单的显示隐藏图标 表格占比
			icon_mune(){
				if(!this.menu_show){
					this.menu_show=true;
					// 显示时的空间占比
					this.active='true-percentage'
				}else{
					this.menu_show=false;
					//隐藏时的空间占比
					this.active='col-lg-12';
				}	
			},
			//当路由是/Sandbox/Setnotice/tbl_notice或者/Sandbox/Setnotice/tbl_horse_lamp时自动查询数据
			auto_query_data(path){
				if(!window.sessionStorage.getItem('project')){
					// alert('444444444')
					var time=new Date().getTime();
					var project={groupOp:'AND'};
					project.rules=[];
					project.rules.push({});
					project.rules[0].field='fld_title_id';
					project.rules[0].op='eq';
					project.rules[0].data=window.sessionStorage.getItem('fld_record_id');
					project=JSON.stringify(project);
					// console.log(this.response.PRIMARY)
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,this.page,this.response.PRIMARY,'desc',project);
					this.userInfo=window.sessionStorage.getItem('userInfo');
					parameter.userInfo=this.userInfo;
					this.change_rows(parameter,path);
				}
			},
			//选择时区
			sle_time(){
				//选择时区时根据本地保存时区和正反序列字段重新加载数据
				window.sessionStorage.setItem('time_zone',this.sle_zone);
				//如果保存的正反序不为null那么获取
				if(window.sessionStorage.getItem('sord')!=null){
					this.sord=window.sessionStorage.getItem('sord');
				};
				//如果路由参数不为undefined根据正反序字段刷新数据
				if (this.$route.params.project != undefined&&this.$route.path != '/Sandbox/Other/server_info'&&this.$route.path != '/Sandbox/Other/QueryRoles') {
					this.parent_refresh(this.sord,this.page)
				}
				//更新时区时根据特定表筛选数据					
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'){	
					this.auto_query_data()					
				}						
			},			
			//选择语言
			change_language(sel_language){
				window.sessionStorage.setItem('sel_language',sel_language);
				this.change_lan(sel_language)
			},
			//计算时区时间
			datetime2zone_x(_date_time, _zone) {
				//定义utc时区字段
				const UTC_ZONE = {
				    "UTC-0000": -0 * 3600 * 1000,
				    "UTC-0100": -1 * 3600 * 1000,
				    "UTC-0200": -2 * 3600 * 1000,
				    "UTC-0300": -3 * 3600 * 1000,
				    "UTC-0400": -4 * 3600 * 1000,
				    "UTC-0500": -5 * 3600 * 1000,
				    "UTC-0600": -6 * 3600 * 1000,
				    "UTC-0700": -7 * 3600 * 1000,
				    "UTC-0800": -8 * 3600 * 1000,
				    "UTC-0900": -9 * 3600 * 1000,
				    "UTC-1000": -10 * 3600 * 1000,
				    "UTC-1100": -11 * 3600 * 1000,
				    "UTC-1200": -12 * 3600 * 1000,
				    "UTC+0000": 0 * 3600 * 1000,
				    "UTC+0100": 1 * 3600 * 1000,
				    "UTC+0200": 2 * 3600 * 1000,
				    "UTC+0300": 3 * 3600 * 1000,
				    "UTC+0400": 4 * 3600 * 1000,
				    "UTC+0500": 5 * 3600 * 1000,
				    "UTC+0600": 6 * 3600 * 1000,
				    "UTC+0700": 7 * 3600 * 1000,
				    "UTC+0800": 8 * 3600 * 1000,
				    "UTC+0900": 9 * 3600 * 1000,
				    "UTC+1000": 10 * 3600 * 1000,
				    "UTC+1100": 11 * 3600 * 1000,
				    "UTC+1200": 12 * 3600 * 1000
				};
				//如果参数返回false返回的显示字段
			    if (!_date_time){
					return "N/A";
					}
				//时区毫秒数
			    var office = UTC_ZONE[_zone];
			    var temp_date = null;
			    if (typeof _date_time == "string") {
					//如果参数是最初时间
			        if (_date_time == "1970-01-01 00:00:00"){
						 return "N/A";
					}
			        //如果参数是0000 
					if (_date_time == "0000-00-00 00:00:00"){
						 return "N/A";
					}
			        //如果参数是null  
			        if (_date_time == "null"){
						return "N/A";
					}
			        //如果字符串没有utc字符
			        if (_date_time.indexOf("UTC") < 0){
						_date_time += " UTC+0000";
						//将’-‘替换成’/‘兼容ie浏览器
						_date_time = _date_time.replace(/\-/g,'/')
						//将字符串转换成时间对象
						temp_date = new Date(_date_time);
					}
					 
				}else{//如果不是字符串
						temp_date = _date_time;
					}
				//返回正确格式的时间字符
			    function to_2_str(_value) {
			        if (_value < 10)
			            return "0" + _value;
			        else
			            return _value;
			    };
				//获取时区的毫秒数
				var temp = new Date(temp_date.getTime() + office);
				//获取带时区的时间
			    var date_str = temp.getUTCFullYear()
			        + "-"
			        + to_2_str(temp.getUTCMonth() + 1)
			        + "-"
			        + to_2_str(temp.getUTCDate())
			        + " "
			        + to_2_str(temp.getUTCHours())
			        + ":"
			        + to_2_str(temp.getUTCMinutes())
			        + ":"
			        + to_2_str(temp.getUTCSeconds())
					+ " " + _zone;
			    return date_str;
			},
			//查询数据
			async query(response,project,sort,page){
				// alert(0)	
				window.sessionStorage.setItem('project',project);
				//加载时的状态
				this.anate=true;
				//接口需要的数据
				this.query_project=project;
				let time = new Date().getTime();
				var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,response.PRIMARY,sort,project);
				parameter.userInfo=JSON.stringify(this.userInfo);
				// alert(6)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				this.project_data=res.data
				// console.log(this.project_data)
				if(!res){
        		  return false
        		};
				// alert(7)
				this.update_timezone(this.$route.path,res);
				//查询数据是否为空
				if(res.data.error==-1){
					this.isquery=false;
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){
					this.isquery=false;
					this.no_data=false;
				}else{
					 this.no_data=true;
				}
				this.sord=sort;
				this.isquery=true;
				this.anate=false;
				window.sessionStorage.setItem('isquery',this.isquery);
			},
			//更新时区
			update_timezone(url,res){
				//更新时区
				if(res.data.rows!=undefined){
					this.project_data = res.data;
					this.total=res.data.total;
						this.fields.map((ite,index,arr)=>{
							if(ite.FieldType=="datetime"||ite.FieldType=="timestamp"){
								 res.data.rows.forEach((item,index)=>{
									item[ite.Name]=this.datetime2zone_x(item[ite.Name],this.sle_zone);
								})
							}
						});
					var rows_list=[];
					if(url=='/Sandbox/Other/EmailSiTitle'){
						res.data.rows.forEach((item,index)=>{
							if(item.fld_type==1){
								rows_list.push(item)
							}
						})
						this.rows=rows_list
					}else if(url=='/Sandbox/Other/EmailTitle'){
						res.data.rows.forEach((item,index)=>{
							if(item.fld_type==0){
								rows_list.push(item)
							}
						})
						this.rows=rows_list
					}else{
						this.rows = res.data.rows;
					}							
				};
			},
			//如果是页面就切换到页面
			switch_page(url,index,pr){
				// alert(0)
				this.anate=false;
				//获取页面参数（组件和参数名一样根据不同的页面参数渲染不同的组件）
				var params=url.split('/');
				this.is_components=params[params.length-1]
				this.sub_url = url;
				this.sub_index = index;
				this.btn_selected=pr;
			},
			//错误提示
			error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
				},2000)
				this.anate=false;
			},
			//根据屏幕高度计算显示多少条数据
			display_number(pageTemplate){
				//计算显示数据的框的高度
				if(pageTemplate=="page_grid"){					
					this.data_page=parseInt((window.screen.height-280)/43-1);
				}else if(pageTemplate=="page_grid_nacos"){
					this.data_page=parseInt((window.screen.height-280)/43-1);
				}else if(pageTemplate=="base_page"){
					this.data_page=parseInt((window.screen.height-355)/53-1);
				}
			},
			//根据页面字段显示哪种模式的页面
			display_template(pageTemplate){
				if(pageTemplate=="page_grid"){
					this.is_components='contentAdmin'
				}else if(pageTemplate=="page_grid_nacos"){
					this.is_components='contentAdmin'
				}else if(pageTemplate=="base_page"){
					this.is_components='contentWarship'
				};
			},
			//加载时区
			load_timezone(url,fields,res1){
				fields.map((ite,index,arr)=>{
					if(ite.FieldType=="datetime"||ite.FieldType=='timestamp'){
						 	res1.data.rows.forEach((item,index)=>{
							//控制时区函数
							item[ite.Name]=this.datetime2zone_x(item[ite.Name],this.sle_zone);
						})
					}
				});
				var rows_list=[];
				if(url=='/Sandbox/Other/EmailSiTitle'){
					res1.data.rows.forEach((item,index)=>{
						if(item.fld_type==1){
							rows_list.push(item)
						}
					})
					this.rows=rows_list
				}else if(url=='/Sandbox/Other/EmailTitle'){
					res1.data.rows.forEach((item,index)=>{
						if(item.fld_type==0){
							rows_list.push(item)
						}
					})
					this.rows=rows_list
				}else{
					this.rows = res1.data.rows;
				}				
			},
			//捕获异步错误
			async_error(promise){
				return promise.then(res => res).catch(error => this.error_message(error));
			},
			//个人邮件请求的数据
			async email_si_title(url, index, pr,sord,project){
				// this.switch_page(url,index,pr)
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'
				){
					// alert(4)
					this.auto_query_data()
				}else{
					// this.is_components='EmailSiTitle'
					// this.switch_page(url,index,pr)
				let page=Number(window.sessionStorage.getItem('page'));
				//加载时的状态
				this.anate=true;
				let time = new Date().getTime();					
				// 每个异步都需要处理
				let res = await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_email_title',window.sessionStorage.getItem('userInfo')));
				if(!res){
        		  	return false
        		};
				//参数正确时返回数据
				if(res!=undefined){
					if(res.data.FIELDS){
						this.response = res.data;
						this.total=res.data.total;
						//获取项目的表头数据 项目表格中的标题
						this.columns = res.data;
						this.fields=res.data.FIELDS;
					}							
					//参数错误时返回错误信息
					if(res.data.error==-1){
						this.error_message(res.data.message)
						return false
					}
					//根据表模板的字段显示不同的页面，做定制表的页面 动态获取页面显示的条数
					this.display_number(this.response.PAGE_TEMPLATE);						
					var flag=project?true:false;
					let filter=JSON.stringify({groupOp:"AND",rules:[{field:"fld_type",op:"eq",data:"1"}]})
					//当求情完成的标志
					// var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sord,JSON.stringify(filter));
					// parameter.userInfo=JSON.stringify(this.userInfo)
					//如果加载接口不为undefined执行数据接口
					if(res.data.JQ_GRID_LOAD!=undefined){	
						this.query(res.data,filter,sord,page)
						// let res1 = await this.async_error(api.getTableList(res.data,parameter));
						// if(!res1){
        				//   return false
        				// };
						// if(res1!=undefined){							
						// 	this.project_data = res1.data;
						// 	this.total=res1.data.total;
						// 	//判断有没有数据
						// 	if(res1.data.rows!=undefined){
						// 		//请求数据后把类型为时间的加上时区信息
						// 		this.load_timezone(url,this.fields,res1)
						// 	}else{//如果没有数据
						// 		this.rows =[];
						// 		this.error_message(this.sel_language.no_data)
						// 	};
						// 	//参数错误时返回错误信息
						// 	if(res1.data.error==-1){
						// 		this.error_message(res1.data.message)
						// 	}
						// 	//显示shop组件 根据表模板字段显示不同的定制页面 表模板设置为哪个字段就显示相应的页面
						// 	this.display_template(this.response.PAGE_TEMPLATE);
						// 	//保存地址及索引用于传递给子组件
						// 	this.sub_url = url;
						// 	this.sub_index = index;
						// 	//项目选择框的数据对象
						// 	this.btn_selected=pr;
						// 	//加载完成的后加载状态消失
						// 	this.anate=false
							this.switch_page(url,index,pr)
						// }
					}
					if(res.data.JQ_GRID_LOAD==undefined){//没有显示权限
						this.error_message(this.sel_language.is_permission)
					}
					
				}
				
						// this.switch_page(url,index,pr)
				}	
			},
			//全服邮件请求数据
			async email_title(url, index, pr,sord,project){
				// alert(5)
				// this.switch_page(url,index,pr)
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'
				){
					// alert(4)
					this.auto_query_data()
				}
				else{
					// this.is_components='EmailTitle'
					// this.switch_page(url,index,pr)
				let page=Number(window.sessionStorage.getItem('page'));
				//加载时的状态
				this.anate=true;
				let time = new Date().getTime();					
				// 每个异步都需要处理
				let res = await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_email_title',window.sessionStorage.getItem('userInfo')));
				// this.isquery=true;
				if(!res){
        		  return false
        		};
				//参数正确时返回数据
				if(res!=undefined){
					if(res.data.FIELDS){
						this.response = res.data;
						this.total=res.data.total;
						//获取项目的表头数据 项目表格中的标题
						this.columns = res.data;
						this.fields=res.data.FIELDS;
					}							
					//参数错误时返回错误信息
					if(res.data.error==-1){
						this.error_message(res.data.message)
						return false
					}
					//根据表模板的字段显示不同的页面，做定制表的页面 动态获取页面显示的条数
					this.display_number(this.response.PAGE_TEMPLATE);						
					var flag=project?true:false;
					// let filter={groupOp:"AND",rules:[{field:"fld_type",op:"eq",data:"0"}]}
					let filter=JSON.stringify({groupOp:"AND",rules:[{field:"fld_type",op:"eq",data:"0"}]})
					//当求情完成的标志
					// var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sord,JSON.stringify(filter));
					// var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sord);
					// parameter.userInfo=JSON.stringify(this.userInfo)
					//如果加载接口不为undefined执行数据接口
					if(res.data.JQ_GRID_LOAD!=undefined){
						// alert(1)	
						this.query(res.data,filter,sord,page)
						// let res1 = await this.async_error(api.getTableList(res.data,parameter));
						// if(!res1){
        				//   return false
        				// };
						// if(res1!=undefined){							
						// 	this.project_data = res1.data;
						// 	this.total=res1.data.total;
						// 	//判断有没有数据
						// 	if(res1.data.rows!=undefined){
						// 		//请求数据后把类型为时间的加上时区信息
						// 		this.load_timezone(url,this.fields,res1)
						// 	}else{//如果没有数据
						// 		this.rows =[];
						// 		this.error_message(this.sel_language.no_data)
						// 	};
						// 	//参数错误时返回错误信息
						// 	if(res1.data.error==-1){
						// 		this.error_message(res1.data.message)
						// 	}
						// 	//显示shop组件 根据表模板字段显示不同的定制页面 表模板设置为哪个字段就显示相应的页面
						// 	this.display_template(this.response.PAGE_TEMPLATE);
						// 	//保存地址及索引用于传递给子组件
						// 	this.sub_url = url;
						// 	this.sub_index = index;
						// 	//项目选择框的数据对象
						// 	this.btn_selected=pr;
						// 	//加载完成的后加载状态消失
						// 	this.anate=false
							this.switch_page(url,index,pr)
						// }
					}
					if(res.data.JQ_GRID_LOAD==undefined){//没有显示权限
						this.error_message(this.sel_language.is_permission)
					}
					
				}
				}
				// this.flag=false
						// this.switch_page(url,index,pr)
			},
			//个人邮件的子条目
			async email_si_child(url, index, pr,sord,project){
				// alert('yyyyyyyy')
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'
				){
					// alert(3)
					// alert(4)
					this.auto_query_data('/Sandbox/Other/EmailSiTitle')
				}else{
				let page=Number(window.sessionStorage.getItem('page'));
				//加载时的状态
				this.anate=true;
				let time = new Date().getTime();					
				// 每个异步都需要处理
				let res = await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_email',window.sessionStorage.getItem('userInfo')));
				if(!res){
        		  return false
        		};
				//参数正确时返回数据
				if(res!=undefined){
					// alert('fffddddd')
					if(res.data.FIELDS){
						this.response = res.data;
						this.total=res.data.total;
						//获取项目的表头数据 项目表格中的标题
						this.columns = res.data;
						this.fields=res.data.FIELDS;
					}							
					//参数错误时返回错误信息
					if(res.data.error==-1){
						this.error_message(res.data.message)
						return false
					}
					//根据表模板的字段显示不同的页面，做定制表的页面 动态获取页面显示的条数
					this.display_number(this.response.PAGE_TEMPLATE);						
					var flag=project?true:false;
					//当求情完成的标志
					var parameter=this.dynamic_interface_parameters(flag,time,this.data_page,page,this.response.PRIMARY,sord,JSON.stringify(project));
					parameter.userInfo=JSON.stringify(this.userInfo)
					//如果加载接口不为undefined执行数据接口
					if(res.data.JQ_GRID_LOAD!=undefined){	
						let res1 = await this.async_error(api.getTableList(res.data,parameter));
						if(!res1){
        				  return false
        				};
						if(res1!=undefined){							
							this.project_data = res1.data;
							this.total=res1.data.total;
							//判断有没有数据
							if(res1.data.rows!=undefined){
								//请求数据后把类型为时间的加上时区信息
								this.load_timezone(url,this.fields,res1)
							}else{//如果没有数据
								this.rows =[];
								this.error_message(this.sel_language.no_data)
							};
							//参数错误时返回错误信息
							if(res1.data.error==-1){
								this.error_message(res1.data.message)
							}
							//显示shop组件 根据表模板字段显示不同的定制页面 表模板设置为哪个字段就显示相应的页面
							this.display_template(this.response.PAGE_TEMPLATE);
							//保存地址及索引用于传递给子组件
							this.sub_url = url;
							this.sub_index = index;
							//项目选择框的数据对象
							this.btn_selected=pr;
							//加载完成的后加载状态消失
							this.anate=false;
							
						}
						// alert('tttttttttt')
						
					}
					if(res.data.JQ_GRID_LOAD==undefined){//没有显示权限
						this.error_message(this.sel_language.is_permission)
					}
					
				}
					this.is_components='ChildEmailSiTitle'
				}
				
					
			},
			//全服邮件的子条目
			async email_child(url, index, pr,sord,project){
				// alert(0)
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'
				){
					this.auto_query_data('/Sandbox/Other/EmailTitle')
				}else{
				let page=Number(window.sessionStorage.getItem('page'));
				//加载时的状态
				this.anate=true;
				let time = new Date().getTime();					
					// 每个异步都需要处理
					let res = await this.async_error(api.getTableHead('/Sandbox/Launcher/tbl_email',window.sessionStorage.getItem('userInfo')));
					if(!res){
        			  return false
        			};
					//参数正确时返回数据
					if(res!=undefined){
						if(res.data.FIELDS){
							this.response = res.data;
							this.total=res.data.total;
							//获取项目的表头数据 项目表格中的标题
							this.columns = res.data;
							this.fields=res.data.FIELDS;
						}							
						//参数错误时返回错误信息
						if(res.data.error==-1){
							this.error_message(res.data.message)
							return false
						}
						//根据表模板的字段显示不同的页面，做定制表的页面 动态获取页面显示的条数
						this.display_number(this.response.PAGE_TEMPLATE);						
						var flag=project?true:false;
						//当求情完成的标志
						var parameter=this.dynamic_interface_parameters(flag,time,this.data_page,page,this.response.PRIMARY,sord,JSON.stringify(project));
						parameter.userInfo=JSON.stringify(this.userInfo)
						//如果加载接口不为undefined执行数据接口
						if(res.data.JQ_GRID_LOAD!=undefined){	
							let res1 = await this.async_error(api.getTableList(res.data,parameter));
							if(!res1){
        					  return false
        					};
							if(res1!=undefined){
								
								this.project_data = res1.data;
								this.total=res1.data.total;
								//判断有没有数据
								if(res1.data.rows!=undefined){
									//请求数据后把类型为时间的加上时区信息
									this.load_timezone(url,this.fields,res1)
								}else{//如果没有数据
									this.rows =[];
									this.error_message(this.sel_language.no_data)
								};
								//参数错误时返回错误信息
								if(res1.data.error==-1){
									this.error_message(res1.data.message)
								}
								//显示shop组件 根据表模板字段显示不同的定制页面 表模板设置为哪个字段就显示相应的页面
								this.display_template(this.response.PAGE_TEMPLATE);
								//保存地址及索引用于传递给子组件
								this.sub_url = url;
								this.sub_index = index;
								//项目选择框的数据对象
								this.btn_selected=pr;
								//加载完成的后加载状态消失
								this.anate=false
							}
						}
						if(res.data.JQ_GRID_LOAD==undefined){//没有显示权限
							this.error_message(this.sel_language.is_permission)
						}
						
					}	
					this.is_components='ChildEmailTitle'
				}
						
			},
			//请求数据
			async get_data(url, index, pr,sord,project){
				// alert('ffffffffff')
				if(
					this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'
				){
					this.auto_query_data()
				}else{
					let page=Number(window.sessionStorage.getItem('page'));
				//加载时的状态
				this.anate=true;
				let time = new Date().getTime();					
					// 每个异步都需要处理
					let res = await this.async_error(api.getTableHead(url,window.sessionStorage.getItem('userInfo')));
					if(!res){
        			  return false
        			};
					//参数正确时返回数据
					if(res!=undefined){
						if(res.data.FIELDS){
							this.response = res.data;
							this.total=res.data.total;
							//获取项目的表头数据 项目表格中的标题
							this.columns = res.data;
							this.fields=res.data.FIELDS;
						}							
						//参数错误时返回错误信息
						if(res.data.error==-1){
							this.error_message(res.data.message)
							return false
						}
						//根据表模板的字段显示不同的页面，做定制表的页面 动态获取页面显示的条数
						this.display_number(this.response.PAGE_TEMPLATE);						
						var flag=project?true:false;
						//当求情完成的标志
						var parameter=this.dynamic_interface_parameters(flag,time,this.data_page,page,this.response.PRIMARY,sord,JSON.stringify(project));
						parameter.userInfo=JSON.stringify(this.userInfo)
						//如果加载接口不为undefined执行数据接口
						if(res.data.JQ_GRID_LOAD!=undefined){	
							let res1 = await this.async_error(api.getTableList(res.data,parameter));
							if(!res1){
        					  return false
        					};
							if(res1!=undefined){
								this.project_data = res1.data;
								this.total=res1.data.total;
								//判断有没有数据
								if(res1.data.rows!=undefined){
									//请求数据后把类型为时间的加上时区信息
									this.load_timezone(url,this.fields,res1)
								}else{//如果没有数据
									this.rows =[];
									this.error_message(this.sel_language.no_data)
								};
								//参数错误时返回错误信息
								if(res1.data.error==-1){
									this.error_message(res1.data.message)
								}
								//显示shop组件 根据表模板字段显示不同的定制页面 表模板设置为哪个字段就显示相应的页面
								this.display_template(this.response.PAGE_TEMPLATE);
								//保存地址及索引用于传递给子组件
								this.sub_url = url;
								this.sub_index = index;
								//项目选择框的数据对象
								this.btn_selected=pr;
								//加载完成的后加载状态消失
								this.anate=false
							}
							this.is_components='contentAdmin'
							
						}
						if(res.data.JQ_GRID_LOAD==undefined){//没有显示权限
							this.error_message(this.sel_language.is_permission)
						}
					}
				}
				
			},
			//获取数据
			async getRow(url, index, pr,sord,project) {
				// alert('sdf')
				// alert(9)
				if(window.sessionStorage.getItem('list_menu_type')!=2&&url!='/Sandbox/Other/EmailSiTitle'&&url!='/Sandbox/Other/EmailTitle'&&url!='/Sandbox/Launcher/tbl_email'){			
					this.get_data(url, index, pr,sord,project,)
					// alert(8)
				}
				if(url=='/Sandbox/Other/EmailSiTitle'){
					// alert(3)
					this.email_si_title(url, index, pr,sord,project)
				}else if(url=='/Sandbox/Other/EmailTitle'){
					// alert(4)
					this.email_title(url, index, pr,sord,project)
				}
				if(window.sessionStorage.getItem('list_menu_type')==2&&url!='/Sandbox/Other/EmailSiTitle'&&url!='/Sandbox/Other/EmailTitle'&&url!='/Sandbox/Launcher/tbl_email'){
					//切换页面
					this.switch_page(url,index,pr)
					// alert(7)
				}
				if(window.sessionStorage.getItem('list_menu_type')==2&&url=='/Sandbox/Launcher/tbl_email'){
					// alert(8)
					//切换页面
					if(window.sessionStorage.getItem('parent_c')=='/Sandbox/Other/EmailSiTitle'){
						// alert(1)
						this.email_si_child(url, index, pr,sord,project)
					}
					if(window.sessionStorage.getItem('parent_s')=='/Sandbox/Other/EmailTitle'){
						// alert(2)
						this.email_child(url, index, pr,sord,project)
					}
				}
			},
			//子组件查找数据点击底部的第几页显示输入框并输入页数
			async lookup(page,sort) {
				//加载状态
				this.anate=true;
				//加载标志本次加载完成在执行下一次的接口请求
				this.istrue.isnext = false;
				let time = new Date().getTime();
				//根据是否查询了数据请求不同的接口
				if(this.isquery==true){	
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,this.query_project);
					//有查询请求时设置一个标志位用于请求下一页数据传递不同的接口
					this.isquery=true;
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'');
					this.isquery=false
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.total=res.data.total;
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};
				//加载完成标志
				this.istrue.isnext = true;					
				 //数据的正反序
				 this.sord=sort;
				 //加载完成状态隐藏
				 this.anate=false;
				//获取当前页
				this.page=page;
				window.sessionStorage.setItem('page',page);
			},
			//子组件刷新数据
			async parent_refresh(sort,page,isquery) {
				this.isquery=Boolean(window.sessionStorage.getItem('isquery'));
				// console.log(this.isquery,project)
				let project=window.sessionStorage.getItem('project')
				//加载状态
				this.anate=true;
				//加载完成的标志
				this.istrue.isrefresh = false;
				let time = new Date().getTime();
				//根据是否加载了查询接口请求不同的接口
				// if(this.isquery==true&&project){	
					// if(this.$route.path=='/Sandbox/Other/EmailTitle'){

					// }
					if(this.isquery==true&&project){
					// alert(2)
						var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,project);
						this.isquery=true
					}else{
						// alert(3)
						var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'');
						this.isquery=false
					}
					parameter.userInfo=JSON.stringify(this.userInfo)
					let res= await this.async_error(api.getTableList(this.response,parameter));
					if(!res){
        			  return false
        			};
					this.project_data = res.data;
					this.total=res.data.total;
					this.update_timezone(this.$route.path,res);
					//接口返回error对象
					if(res.data.error==-1){
						this.sel_tips=true;
						this.current_state=res.data.message;
						window.setTimeout(()=>{
					   		this.sel_tips=false
						},2000)
					}else if(res.data.rows.length==0){//如果没有数据
						 	this.no_data=false;
					}else{
						 this.no_data=true;
					};
					//当数据请求完成时istrue赋值true此时子组件才能继续请求下一个接口
					this.istrue.isrefresh = true
					//加载状态完成后消失
					this.anate=false;
					//数据的正反序
					this.sord=sort;	
					if(this.$route.path=='/Sandbox/Launcher/tbl_notice'||
					this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_emailSi'||
					this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'){
						if(this.$route.path=='/Sandbox/Launcher/tbl_email'){
							this.auto_query_data('/Sandbox/Other/EmailSiTitle')
						}else if(this.$route.path=='/Sandbox/Launcher/tbl_email'){

						}else{
							this.auto_query_data()
						}
						
					}
			},
			//子组件调用父组件方法刷新数据正倒序
			async parent_data_sort(sort,name,page) {
				//加载的状态
				this.anate=true;
				//加载完成的标志
				this.istrue.isorder = false;
				let time = new Date().getTime();
				//当调用查询接口后请求的接口
				if(this.isquery==true){
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,name,sort,this.query_project);
					this.isquery=true;
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,name,sort,'');
					this.isquery=false;
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				//刷新数据时特有路由执行筛选接口
				if(this.$route.path=='/Sandbox/Launcher/tbl_notice'||
				this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
				this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
				// this.$route.path=='/Sandbox/Launcher/tbl_email'||
				this.$route.path=='/Sandbox/Launcher/tbl_emailSi'||
				this.$route.path=='/Sandbox/Launcher/tbl_giftpackageSi'){
					this.auto_query_data();
					return false
				}
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.total=res.data.total;
				//更新时区
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};
				//当数据请求完成时istrue赋值true此时子组件才能继续请求下一个接口
				this.istrue.isorder = true;
				//加载状态
				this.anate=false;
				//当点击正反序的时候从第一页开始
				this.page=1;
				//在本地存储当前的正反序字段
				window.sessionStorage.setItem('sord',sort);
			},
			//首页加载
			async child_home(page,sort) {
				//加载状态
				this.anate=true;	
				//加载完成的标志	
				this.istrue.isstart = false;
				let time = new Date().getTime();
				//判断是否是请求的查询接口如果是那么走查询接口如果不是走原始的数据接口
				if(this.isquery==true){	
					// laert(1)
						var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,this.query_project);
						window.sessionStorage.setItem('page',1);
						this.isquery=true
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'');
					window.sessionStorage.setItem('page',page);
					this.isquery=false
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.rows=res.data;
				// console.log(this.project_data)
				this.total=res.data.total;
				//更新时区
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};
				//当数据请求完成时istrue赋值true此时子组件才能继续请求下一个接口
				this.istrue.isstart = true;
				//加载状态
				this.anate=false;	
			},
			//子组件执行父组件方法上一页
			async child(page,sort) {
				//加载状态
				this.anate=true;
				//加载完成的标志
				this.istrue.isfirst = false;
				let time = new Date().getTime();
				//有查询的加载接口
				if(this.isquery==true){
						var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,this.query_project);
						window.sessionStorage.setItem('page',1);
						this.isquery=true;
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'');
					window.sessionStorage.setItem('page',page);
					this.isquery=false
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.rows=res.data;
				this.total=res.data.total;
				//更新时区
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};
				//加载完成的标志
				this.istrue.isfirst = true;
				 //加载的状态
				this.anate=false;
			},
			//动态接口参数
			dynamic_interface_parameters(search,nd,rows,page,sidx,sord,filters){
				return {
					_search:search,
					nd:nd, 
					rows:rows, 
					page:page, 
					sidx:sidx, 
					sord:sord, 
					filters:filters, 
					searchField:'', 
					searchString:'', 
					searchOper:'',
				}
			},
			//子组件执行父组件方法下一页
			async child_next(index, page,sort) {
				// console.log(page)
				//加载的状态
				this.anate=true;
				//加载完成的标志
				this.istrue.isnext = false;
				let time = new Date().getTime();
				//有查询时的请求接口
				if(this.isquery==true){
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,this.query_project)
					window.sessionStorage.setItem('page',1);
					this.isquery=true
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'')
					window.sessionStorage.setItem('page',page);
					this.isquery=false
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.rows=res.data;
				this.total=res.data.total;
				//更新时区
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};	
				//当数据请求完成时istrue赋值true此时子组件才能继续请求下一个接口
				this.istrue.isnext = true;
				// console.log(this.istrue.isnext)
				//加载状态
				this.anate=false;
			},
			//尾页加载
			async child_end(index, page,sort) {
				//加载的状态
				this.anate=true;
				//当执行时不能点击尾页的标志
				this.istrue.isend = false;
				let time = new Date().getTime();
				//如果是查询完成的列表则执行
				if(this.isquery==true){
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,page,this.response.PRIMARY,sort,this.query_project);
					window.sessionStorage.setItem('page',1);
					this.isquery=true
				}else{
					var parameter=this.dynamic_interface_parameters(false,time,this.data_page,page,this.response.PRIMARY,sort,'');
					window.sessionStorage.setItem('page',page);
					this.isquery=false
				}
				parameter.userInfo=JSON.stringify(this.userInfo)
				let res= await this.async_error(api.getTableList(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.project_data = res.data;
				this.rows=res.data;
				this.total=res.data.total;
				//更新时区
				this.update_timezone(this.$route.path,res);
				//接口返回error对象
				if(res.data.error==-1){
					this.sel_tips=true;
					this.current_state=res.data.message;
					window.setTimeout(()=>{
				   		this.sel_tips=false
					},2000)
				}else if(res.data.rows.length==0){//如果没有数据
					 	this.no_data=false;
				}else{
					 this.no_data=true;
				};	
				//当数据请求完成时istrue赋值true此时子组件才能继续请求下一个接口
				this.istrue.isend = true;
				//加载状态
				this.anate=false;				
			},
			//如果有url字段那么执行外部链接sdk,nacos
			perform_external_links(url){
				// console.log('传过来的url',url)
				if(url!=''){
					// console.log('传过来的url1',url,this.$route.fullPath)
					window.sessionStorage.setItem('router',this.$route.fullPath);
					window.sessionStorage.setItem('language',this.sel_language)
					if(url=='/nacos/index.html'){
						// console.log('传过来的url2',url)
						if(window.sessionStorage.getItem('nacos_hash')!=null){
							window.location.href='/dist' + url+window.sessionStorage.getItem('nacos_hash');
						}else{
							// console.log('传过来的url4',url)
							window.location.href='/dist' + url
						}							
					}
					if(url=="/sdk/index.html"){
						if(window.sessionStorage.getItem('sdk_hash')!=null){
							window.location.href='/dist' + url+window.sessionStorage.getItem('sdk_hash');
						}else{
							window.location.href='/dist' + url
						}
					}
				};
			},
			//左边菜单栏name:项目对象 url:后台路由 index:菜单索引 chang_index:子菜单索引
			async menu_list(pro,url,index, change_index) {
				//选中某一项把项目索引赋值给project_index后续使用
				if(pro!=undefined){
					this.project_list.forEach((item,index)=>{
						if(item.Name==pro.Name){
							this.project_index=index;
						}
					});
					//如果有url字段那么执行外部链接sdk,nacos
					this.perform_external_links(pro.url.trim())
					//显示左侧菜单
					this.menu_show=true;
					//控制菜单的显示宽度
					this.active='true-percentage';
					//项目的项目名
					this.project_name = pro.Name;
					//请求项目菜单
					let res= await this.async_error(api.getProjectMenu(pro.Name,window.sessionStorage.getItem('userInfo')));
					if(!res){
        			  return false
        			};
					this.menu_data = res.data;
					this.is_icon = null;
					this.menu_data.forEach((item,index)=>{
						item.sub_item.forEach((change_item,change_index)=>{
							if(url==change_item.url){
								window.sessionStorage.setItem('index',change_index);
								window.sessionStorage.setItem('change_index',index);
								this.index=Number(window.sessionStorage.getItem('index'));
								this.change_index=Number(window.sessionStorage.getItem('change_index'));
							}
						})
					})
					//改变小三角样式的函数
					if(change_index!=undefined){
						this.change(this.change_index,this.menu_data[this.change_index].sub_item[this.index].name);
					}	
				}else{
					return false
				};		
			},
			//控制菜单栏的显示隐藏
			change(index) {		
				window.sessionStorage.setItem('change_index',index);
				//获取菜单的索引
				this.change_index = index;
				//子菜单的样式选项为空
				this.is_sty = window.sessionStorage.getItem('title')+window.sessionStorage.getItem('index');
				//控制小三角的样式
				if (this.is_icon === index) {
					this.is_icon = '';
				} else {
					this.is_icon = index
				}
			},
			//点击项目菜单
			sty_list(sub, index){
				window.sessionStorage.setItem('page',1)
				window.sessionStorage.setItem('title',sub.name);
				this.title=sub.name;
				//每次切换项目就把btn_selected设置为最新的值)
				window.sessionStorage.setItem('btn_selected',this.project_index);
				window.sessionStorage.setItem('index',index);
				this.$router.push(sub.url);
				window.sessionStorage.setItem('list_menu_type',sub.type);
				// this.flag=true;
			},
			//退出登录
			out() { 
				document.title='Background-management-system';
				window.sessionStorage.setItem('index',this.index);
				if(this.project_list[this.copy_select]){
					//保存选择项的索引
					window.sessionStorage.setItem('btn_selected',this.project_index);
					//保存推出前的地址
					if(this.$route.params.project != undefined){
						window.sessionStorage.setItem('url',this.surl);
					};
				}
				//保存userInfo
				window.sessionStorage.setItem('userInfo','null');				
				//返回登录页面
				this.$router.replace({
					path: "/login"
				})
			}
		}
	}
</script>
<style scoped>
	@media (min-width: 1024px){
		.true-percentage{
			margin-left: 160px;
			width: 85%;
		}
	}
	@media (min-width: 1100px) {
		.true-percentage{
			margin-left: 160px;
			width: 86%;
		}
	}
	@media (min-width: 1280px) {
		.true-percentage{
			margin-left: 160px;
			width: 89%;
		}
	}
	@media (min-width: 1366px) {

		.true-percentage{
			margin-left: 160px;
			width: 90%;
		}
	}  
	@media (min-width: 1440px) {
		.true-percentage{
			margin-left: 160px;
			width: 90%;
		}
	} 
	@media (min-width: 1680px) {
		.true-percentage{
			margin-left: 160px;
			width: 92%;
		}
	} 
	@media (min-width: 1920px) {
		.true-percentage{
			margin-left: 160px;
			width: 92%;
		}
	} 
    .edition{
		height: 30px;
	}
    .copyright{
		height: 30px;
		line-height: 30px;
		background-color: #969191;
		color: #fff;
		text-align: center;
		margin-bottom: 0px;
		position: fixed;
    	margin-left: 15px;
    	bottom: 0;
    	width: 100%;
		z-index: 2;
	}
    .left-menu{
		color:#fff ;
		cursor: pointer;
	}
    .user_icon{
		font-family: cursive;
		padding: 0 5px;
        color: #fff;
        font-weight: 400;
	}
	.fa-spin{
	    -webkit-animation: fa-spin 1s infinite linear;
        animation: fa-spin 1s infinite linear;
	}
	.loading{
		z-index: 1;
		font-size: 50px;
		position: fixed;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
	}
	.loading p{
		font-size: 20px;
		width: 120px;
		height: 30px;
		background: darkkhaki;
		color: #fff;
	}
	.home{
		overflow: hidden;
	}
    .data{
		 /* margin-top: 20px; */
		 /* width: 100%; */
		 padding-left: 1px;
		 padding-right: 20px;
	 }
	 select{
		font-size: 14px;
	}
    .z_load{
		position: absolute;
		top: 50%;
		left: 50%;
	}
	a {
		color: black;
	}
	a:hover {
		text-decoration: none
	}
	.header {
		position: fixed;
		z-index: 1000;
		width: 100%;
	}
	.container-fluid {
		padding-left: 0;
		padding-right: 0;
	}
	.project_list {
		cursor: pointer;
	}
	.list-anchor {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		width: 100px;
		overflow: hidden;
		white-space: nowrap;
        text-overflow: ellipsis;
	}
	.menu {
		/* width: 10%; */
		z-index: 2;
		background: gainsboro;
		position: fixed;
		top: 52px;
		bottom: 0px;
		overflow: auto;
		/* margin-bottom: 10px; */
		width: 174px;
		padding-right: 0;
	}
	.icon {
		transform: rotate(90deg);
	}
	.navbar-header {
		color: #ffffff;
	}
	.navbar-rigth {
		margin-right: 10px;
		color: #ffffff;
		font-size: 15px;
	}
	.navbar-rigth a{
		color:#fff;
	}
	.active {
		display: block;
	}
	.menu-titel {
		width: 100%;
		text-align: left;
		padding-left: 20px;
		cursor: pointer;
		font-size: 15px;
		/* margin-top: 20px; */
		height: 40px;
		line-height: 40px;
		margin-left: 12px;
    	border-radius: 5px;
		user-select: none;
    	/* box-shadow: #fff 5px 5px 5px 5px; */
	}
	.menu-titel:hover {
		background: ghostwhite;
	}
	.menu-list {
		margin-left: -40px;
		margin-right: -15px;
		/* margin-top: 10px; */
    	text-align: left;
    	/* margin-right: 20px; */
	}
	.menu-list li {
		font-size: 13px;
		cursor: pointer;
		padding-left: 52px;
		border-radius: 10px;
    	height: 40px;
    	line-height: 40px;
		margin-top: 5px;
	}
	.menu-list li:hover {
		background-color: ghostwhite;
	}
	.sty_list {
		background-color: ghostwhite;
	}
	.menu-list-one {
		margin-bottom: 10px;
		font-size: 40px;
		text-align: center;
		color: #666;
		font-size: 30px;
	}
	ul li {
		list-style: none;
	}
	.logo {
		width: 117px;
	}
	select {
		outline: none;
	}
	.out {
		cursor: pointer;
	}
	nav {
		padding: 0;
		background: gray;
	}
	span {
		margin-left: 20px;
	}
	.menu::-webkit-scrollbar {
		width: 4px;
	}
	.menu::-webkit-scrollbar-thumb {
		border-radius: 10px;
		/* -webkit-box-shadow: inset 0 0 5px rgba(173, 172, 172, 0.2); */
		background: rgba(173, 172, 172, 0.2);
	}
	.menu::-webkit-scrollbar-track {
		/* -webkit-box-shadow: inset 0 0 5px rgba(173, 172, 172, 0.2); */
		border-radius: 0;
		background: rgba(173, 172, 172, 0.1);
	}
</style>
